var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBackgroundPastelBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 541.846,
    height: 546.444,
    viewBox: "230 0 541.846 546.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(8,133,213,0.19)",
    stroke: "rgba(0,0,0,0)",
    d: "M270.425,545.444a270.209,270.209,0,0,1-54.5-5.541,267.744,267.744,0,0,1-96.7-41.035A272.846,272.846,0,0,1,5.494,327.686a277.676,277.676,0,0,1,0-109.927A273.049,273.049,0,0,1,119.228,46.577a268.33,268.33,0,0,1,302.392,0A272.848,272.848,0,0,1,535.351,217.759a277.687,277.687,0,0,1,0,109.927A273.042,273.042,0,0,1,421.62,498.868a267.652,267.652,0,0,1-151.2,46.576Zm38.6-420.207A191.638,191.638,0,0,0,156.1,200.426c-64.877,84.246-49.12,205.566,35.125,270.445a192.816,192.816,0,0,0,270.444-35.125C526.551,351.5,510.794,230.179,426.548,165.3A191.023,191.023,0,0,0,309.026,125.237Z",
    transform: "translate(0.5 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackgroundPastelBlue);
export default __webpack_public_path__ + "static/media/logo-background-pastel-blue.95ecd0510688be5aba9cb32b02f1563d.svg";
export { ForwardRef as ReactComponent };